import "./spinner-icon.styles.css";

export default function SpinnerIcon() {
  return (
    <lord-icon
      class="spinner-icon"
      src="https://cdn.lordicon.com/ymrqtsej.json"
      trigger="loop"
      colors="primary:#a6cdde"
    />
  );
}
